module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "Aut"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Aut",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMCO-1"
  }, [_vm._v("Reader beware: All names and identifying characteristics have been changed. Certain events have been reordered and some characters and scenes are composites.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-124e41c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authorsnote.vue
// module id = 69
// module chunks = 0